import category from './category'
import type_ from './type'
import load from './load'
import brand from './brand'

export default {
  name: 'BaseInfoCar',
  path: 'car',
  meta: {
    label: 'car',
    auth: 'car'
  },
  component: {
    name: 'Car',
    render(c) {
      return c('router-view')
    }
  },
  children: [category, type_, load, brand]
}
